import React, { useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Upload, Loader2, Check } from "lucide-react";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export default function ImageUpload({ label = "Upload image", onUploaded, testid = "image-upload" }) {
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const handle = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    if (file.size > 15 * 1024 * 1024) {
      toast.error(`Image is ${(file.size / (1024 * 1024)).toFixed(1)}MB — the limit is 15MB. Please compress or resize it.`);
      e.target.value = "";
      return;
    }
    setBusy(true); setDone(false);
    const fd = new FormData();
    fd.append("file", file);
    try {
      const { data } = await api.post("/upload", fd);
      onUploaded(`${BACKEND}${data.url}`);
      setDone(true);
      toast.success("Image uploaded");
    } catch (err) {
      const detail = err.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Upload failed — please try a smaller PNG/JPG.");
    } finally { setBusy(false); e.target.value = ""; }
  };

  return (
    <label className="flex items-center gap-2 text-sm text-[#94A3B8] border border-dashed border-white/15 rounded-md px-3 py-2.5 cursor-pointer hover:border-[#00F0FF]/50 transition" data-testid={testid}>
      {busy ? <Loader2 className="w-4 h-4 animate-spin text-[#00F0FF]" /> : done ? <Check className="w-4 h-4 text-[#10B981]" /> : <Upload className="w-4 h-4" />}
      <span>{busy ? "Uploading…" : done ? "Uploaded — choose another to replace" : label}</span>
      <input type="file" accept="image/png,image/jpeg,image/webp,image/gif,image/svg+xml,image/avif,image/bmp,image/tiff" className="hidden" onChange={handle} />
    </label>
  );
}
